import { Button, ButtonProps, HStack, Text } from '@chakra-ui/react'

import { useIsDark } from '../../../hooks/useIsDark'
import { Icon } from '../../Icons/Icon'
import { Tooltip } from '../../Tooltip/Tooltip'

export interface FilterButtonProps extends ButtonProps {
  isOpen?: boolean
  hasFiltersApplied?: boolean
  /** When set, overrides Chakra color mode for dark/light styling. */
  colorMode?: 'light' | 'dark'
}

export const FilterButton = ({
  hasFiltersApplied = false,
  isOpen = false,
  colorMode: colorModeOverride,
  ...props
}: FilterButtonProps) => {
  const isDark = useIsDark(colorModeOverride)

  const button = (
    <Button
      data-testid="filter-button"
      variant="tertiary"
      borderRadius="4px"
      padding="6px"
      height="32px"
      minWidth="32px"
      color={isDark ? 'presets.neutral.0' : 'presets.neutral.90'}
      bg={isDark && isOpen ? 'presets.turquoise.90' : 'transparent'}
      border={
        isDark
          ? '1px solid'
          : '1px solid var(--color-presets-neutral-20, #DEDEDE)'
      }
      borderColor={
        isDark
          ? 'presets.overlay.turquoise40'
          : isOpen
            ? 'presets.neutral.90'
            : undefined
      }
      _hover={{
        bg: 'transparent',
        borderColor: isDark ? 'presets.turquoise.40' : 'presets.turquoise.60',
      }}
      _active={{
        borderColor: isDark ? 'presets.turquoise.40' : undefined,
        bg: isDark ? 'presets.overlay.turquoise90_40' : 'presets.turquoise.10',
      }}
      {...props}
    >
      <HStack gap="6px" alignItems="center">
        <Icon
          icon="FilterIcon"
          boxSize="16px"
          color={isDark ? 'presets.neutral.0' : 'presets.neutral.100'}
        />
        {!hasFiltersApplied && (
          <Text fontSize="12px" fontWeight="600">
            Filters
          </Text>
        )}
      </HStack>
    </Button>
  )

  return hasFiltersApplied ? (
    <Tooltip label="Filters applied" placement="top">
      {button}
    </Tooltip>
  ) : (
    button
  )
}
